import styled from 'styled-components'
import { Flex, Box, getPaletteColor, Card, Stamp, Text } from 'pcln-design-system'
import Accordion from '@pcln/accordion'

export const Wrapper = styled(Card)`
  position: relative;
  background-color: ${getPaletteColor('background.lightest')};
  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.md};
    border: solid ${getPaletteColor('border.dark')} 1px;
  }
  height: fit-content;

  div[class^='Popover_'] {
    display: block;
  }
`

export const MobileHeader = styled(Flex)`
  border-bottom: solid ${getPaletteColor('border.base')} 1px;
  flex-wrap: wrap;
  ${(props) => props.theme.mediaQueries.md} {
    display: none;
  }
  > * {
    margin-top: 8px !important;
  }
`

export const SliceDetailsWrapper = styled(Flex)`
  ${(props) => props.theme.mediaQueries.sm} {
    padding: 16px 32px 16px 16px;
    width: 72%;
  }
`

export const CreditAppliedStamp = styled(Stamp)`
  border: solid ${getPaletteColor('highlight.light')} 1px;
  min-height: 20px;
`

export const TrayWrapper = styled(Box)`
  border-top: solid ${getPaletteColor('border.base')} 1px;
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(calc(33.3% - 48px), 1fr));
`

export const CursorStyles = styled(Box)`
  cursor: pointer;
`

export const ShowHideAddonsLinks = styled(Text)`
  &:hover {
    color: ${getPaletteColor('primary.dark')};
  }

  white-space: nowrap;
`

export const StyledAccordionTrigger = styled(Accordion.Trigger)``
